// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mapping-instruction[data-v-6103c358]{border-top:1px solid #e1e1e1}.menu-fields[data-v-6103c358]{height:60px}.rounded-lg[data-v-6103c358]{box-shadow:0 2px 2px 0 rgba(0,0,0,.04)!important}[data-v-6103c358] .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot{padding:0 24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
